import React, { useState,useEffect } from 'react';
import { Container,Row,Col,Card,Image,Placeholder } from 'react-bootstrap';
import Slider from "react-slick";
import './focusUtils';
const ConvocationMain = ({sp}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[hpSlider,setSlider]=useState([]);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    //const[ytLink,setYtLink]=useState("");
    const stArray = {260:18,303:21,310:24,337:30,374:35};
    //const ytArray = {260:"QvopiHK40MU",303:"QvopiHK40MU",310:"0V20KHlKIPs",337:"0kluV-t40wU",374:"0kluV-t40wU"};
    const mtArray = {310:49,303:50,260:51,337:52,374:53};
    useEffect(()=>
    {
        const getSlider = async (stId) => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"slider/byType/"+stId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].slideImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].slideImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setSlider(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Slider File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setSlider([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('Slider : Result',result); }         
            }
            catch (error) 
            {
                console.error('Slider : Error', error.message);
                setLoading(false);
            }
        };
        const MiscellaneousByTypeAll = async (mtId) => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+mtId);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscFileHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneous(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('MiscellaneousType Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneous([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeAll : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByTypeAll : Error', error.message);
            }
        };
        if(sp?.sp_id > 0 )
        {            
            getSlider(stArray[sp.sp_id]);
            MiscellaneousByTypeAll(mtArray[sp.sp_id]);
            //setYtLink(ytArray[sp.sp_id])
        }
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides();
        // eslint-disable-next-line 
    },[sp]);
    const settings = 
    {
        autoplay: true,
        centerMode: false,
        infinite: hpSlider.length > 1,
        centerPadding: "0px",
        dots: hpSlider.length > 1,
        slidesToShow: 1,
        speed: 500,
        accessibility: true,
        arrows: false,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 1 }} ]
    };
    const videoSettings = {
        autoplay: false,
        infinite: Miscellaneous.length > 1,   // ✅ FIX
        dots: Miscellaneous.length > 1,       // ✅ FIX
        arrows: false,     // ✅ FIX (optional)
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        beforeChange: () => window.disableFocusInHiddenSlides(),
        afterChange: () => window.enableFocusInVisibleSlides(),
    };
    const getEmbedUrl = (url) => {
        if (!url) return "";

        // extract video ID
        let videoId = "";

        if (url.includes("youtube.com/watch?v=")) {
            videoId = url.split("v=")[1]?.split("&")[0];
        } else if (url.includes("youtube.com/live/")) {
            videoId = url.split("live/")[1]?.split("?")[0];
        } else if (url.includes("youtu.be/")) {
            videoId = url.split("youtu.be/")[1]?.split("?")[0];
        } else if (url.includes("embed/")) {
            return url; // already embed
        }

        return videoId
            ? `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&cc_load_policy=1`
            : "";
    };
    return (
        <section style={{backgroundImage: `url(${global.config.uploadPath+'1274496370.png'})`, backgroundSize: "cover", backgroundRepeat: "no-repeat"}}>
            <Container className="py-md-5 py-4 text-center">
                <Row className="row-cols-1 row-cols-md-2">
                    <Col>
                        <Card className='bg-info-subtle border-0 h-100'>
                            <Card.Body className='pb-5'>
                            {isLoading ? (
                            <Slider {...settings}>
                                {[...Array(5)].map((_,index)=>(
                                <div key={index}>
                                    <Placeholder xs={12} className="d-block w-100" style={{height:"400px"}} />
                                </div>
                                ))}
                            </Slider>
                            ) : (
                            <Slider {...settings}>
                                {hpSlider.map((hs, index)=>(
                                    <div key={index}>
                                    {appLanguage === 'hi' ? 
                                        (
                                            hs.ss_display_en === "1" && hs.slideImageHi ? 
                                            <Image src={hs.slideImageHi} fluid width={1400} height={440} alt={hs.ss_name_hi} loading="lazy" /> 
                                            : hs.slideImageHi ? 
                                            <Image src={hs.slideImageHi} fluid width={1400} height={440} alt={hs.ss_name_hi} loading="lazy" /> 
                                                : hs.slideImage ?
                                                <Image src={hs.slideImage} fluid width={1400} height={440} alt={hs.ss_name_hi} loading="lazy" /> 
                                                : null
                                        ) : (
                                            hs.slideImage ? 
                                            <Image src={hs.slideImage} fluid width={1400} height={440} alt={hs.ss_name} loading="lazy" /> 
                                            : null
                                        )
                                    }
                                    </div>              
                                ))}
                            </Slider>
                            )}
                            </Card.Body>
                        </Card>                    
                    </Col>
                    <Col>
                        <Card className='bg-info-subtle border-0 h-100'>
                            <Card.Body className='pb-5'>
                                {isLoading ? (
                                    <div className="ratio ratio-4x3">
                                        <Placeholder xs={12} style={{ height: "300px" }} />
                                    </div>
                                ) : (
                                    <Slider {...videoSettings}>
                                        {Miscellaneous.map((sm, index) => (
                                            <div key={index}>
                                                <div className="ratio ratio-16x9 overflow-hidden">                                                    
                                                    {sm.miscFile ? (
                                                        <video controls width="100%" height="100%">
                                                            <source src={sm.miscFile} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    ) : (
                                                        <iframe
                                                            src={getEmbedUrl(sm.sm_link)}
                                                            title={`Video ${index}`}
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                            allowFullScreen
                                                            loading="lazy"
                                                            width="100%"
                                                            height="100%"
                                                        ></iframe>
                                                    )}

                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );    
}
export default ConvocationMain;